import StateView from "./StateView";

// "No rows" for a list that loaded fine. When the list is empty *because of a
// search or filter*, pass the clearing action so the user isn't stuck.
const EmptyState = ({
  title = "Nothing here yet",
  description,
  actionLabel,
  onAction,
}) => (
  <StateView
    actionLabel={actionLabel}
    description={description}
    onAction={onAction}
    title={title}
    variant="empty"
  />
);

export default EmptyState;
